// extracted by mini-css-extract-plugin
export default {"priceInfo":"PriceInfo_priceInfo__SWoW0","priceCategory":"PriceInfo_priceCategory__yk4Am","active":"PriceInfo_active__cIO2W","small":"PriceInfo_small__+VEWx"};